import httpClient from '../../api/httpClient'
import router from '../../router'

export default {
  namespaced: true,
  state: {
    store: {},
    offers: {},
    pagination: { current: 1, totalPages: 0 },
    storeLoading: true,
  },

  mutations: {
    update(state, { path, value }) {
      state[path] = value
    },
  },

  getters: {
    offersPerPage: ({ offers, pagination: { current } }) => offers[current] || [],
    pagination: ({ pagination }) => pagination,
  },

  actions: {
    getStore({ commit }, id) {
      commit('update', { path: 'storeLoading', value: true })
      httpClient
        .get(`/stores/${id}`)
        .then((res) => {
          commit('update', { path: 'store', value: res.data })
        })
        .catch((error) => {
          console.error(`Couldn't fetch store (id = ${id}), `, error)
        })
        .finally(() => {
          commit('update', { path: 'storeLoading', value: false })
        })
    },

    async getOffersV2({ commit, state }, { storeId, userId, page = 1, filter = [], targetUserId }) {
      const isCreatedByUser = filter.includes('created_by_me')
      const filterValues = filter.filter((item) => item !== 'created_by_me')
      let statusParams = ''
      if (filterValues.length) statusParams = `&${filterValues.map((status) => `statuses[]=${status}`).join('&')}`

      const params = {
        page,
        'store_ids[]': storeId,
        sort_by: 'priority:desc',
        ...(isCreatedByUser && { created_by: userId }),
        ...(targetUserId && { target_user_id: targetUserId }),
      }
      const url = `/v2/offers?${statusParams}&${new URLSearchParams(params).toString()}&include[]=targets&include[]=trafficSourcesCosts`
      const response = await httpClient.get(url)

      const {
        meta: { current_page, last_page },
        data,
      } = response.data
      let value = { [current_page]: data }
      if (current_page !== 1) {
        value = { ...state.offers, ...value }
      }
      commit('update', { path: 'offers', value })
      commit('update', { path: 'pagination', value: { totalPages: last_page, current: current_page } })
    },

    async addOneTimePayment({ state }, { oneTimePayment }) {
      // oneTimePayment.invoice_amount = Math.round(oneTimePayment.invoice_amount * 100);
      // oneTimePayment.user_earnings = Math.round(oneTimePayment.user_earnings * 100);
      oneTimePayment.user_earnings = oneTimePayment.user_earnings ? oneTimePayment.user_earnings * 100 : null
      oneTimePayment.invoice_amount = oneTimePayment.invoice_amount ? oneTimePayment.invoice_amount * 100 : null

      oneTimePayment.user_id = oneTimePayment.user_id == '' ? null : oneTimePayment.user_id
      const response = await httpClient.post(`/admin/one-time-earnings`, oneTimePayment)
      state.store.one_time_earnings.unshift(response.data)
    },

    async duplicateStore(_, storeId) {
      const response = await httpClient.post(
        `/admin/stores/${storeId}/duplicate`,
        {},
      )
      router.push({ name: 'Edit Store', params: { id: response.data.id } })
    },

    async destroyStore(_, { store }) {
      await httpClient.delete(`/stores/${store.id}`)
      router.push({ name: 'Stores' })
    },

    async deleteOneTimePayment({ state }, { oneTimePayment }) {
      await httpClient.delete(`/admin/one-time-earnings/${oneTimePayment.id}`)
      state.store.one_time_earnings = state.store.one_time_earnings.filter((one_time_earning) => one_time_earning.id != oneTimePayment.id)
    },
  },
}
